<script setup lang="ts">
const { slice, index } = defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
})

const banner = computed(() => {
  return {
    ...slice?.Banner,
    ContentPosition: 'below',
  }
})

const getStyle = computed(() => {
  return {
    '--slice-bgcolor': slice?.Settings?.BackgroundColor || '#1A2B3C',
    '--slice-color': useContrastColor((slice?.Settings?.BackgroundColor || '#1A2B3C'), 'var(--color-copy-reverse)', 'var(--color-copy-default)'),
  }
})
</script>

<template>
  <section
    v-if="banner"
    class="ct-banner-with-media"
    :class="{ 'ct-banner-with-media--mirrored': slice?.BannerToTheRight }"
    :style="getStyle"
  >
    <div class="ct-banner-with-media__grid">
      <UiHeading
        v-if="slice?.Settings?.Title"
        class="ct-banner-with-media__heading"
        :force-tag="slice?.Settings?.TitleTag || 'div'"
      >
        {{ slice?.Settings?.Title }}
      </UiHeading>

      <UiHeadingSection>
        <div class="ct-banner-with-media__content">
          <StrapiBanner
            :banner="banner"
            :banner-count="1"
            :lazy="index > 0"
            class="ct-banner-with-media__banner"
          />

          <StrapiButton
            v-if="slice?.Settings?.Button"
            :button="slice.Settings.Button"
          />
        </div>

        <StrapiMedia
          class="ct-banner-with-media__media"
          :media="slice?.Media"
          :lazy="index > 0"
          :banner-count="slice?.Files?.length"
          :full-width="slice?.Settings?.SliceWidth?.toLowerCase() === 'full_width'"
        />
      </UiHeadingSection>
    </div>
  </section>
</template>

<style>
@import url("~layers/components/Slices/BannerWithMedia.css");
</style>
